import { Flex } from 'antd'

type Props = {
  fieldKey: number
}

export const ItemCategoryBFields = ({ fieldKey: _ }: Props) => {
  return <Flex>{/* <Typography.Text>Coming soon...</Typography.Text> */}</Flex>
}
